import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { EmployeeService } from '../employee.service';
import {HttpResponse, HttpEventType } from '@angular/common/http';
import { config, Observable,Subject } from "rxjs";
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { MatRadioButton } from '@angular/material/radio';
import { environment }  from '../../environments/environment';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

import { Config } from 'protractor';
import { overrideProvider } from '@angular/core/src/view';

export interface Orders {
  employeeId: number;
  lineItems: [];
  notes : string;
  orderId: number;
  isSelected: boolean;
}

@Component({
  selector: 'app-tsc-reorder-approval',
  templateUrl: './tsc-reorder-approval.component.html',
  styleUrls: ['./tsc-reorder-approval.component.css']
})


export class TscReorderApprovalComponent implements OnInit {
  
  params: Params;
  constructor(private employeeservice:EmployeeService,private route: ActivatedRoute) { }

  employeesArray: any[] = [];
  
  selectedEntry:any;
  approval:any;
  i:any;
  id:number;
  notes: string = '';
  itemid : string = '';
  status : any[] =[];
 notesi: string = '';
  approvalItems: any;
  approvalItem: any;
  values = [];
  notesiArry: any[] = [];
  actual_status: string ='';
  title=environment.title;
  baseUrl=environment.baseUrl;
  approvalItemsNew: any[]; 
  message = '';
  closeAlertMessage: boolean = false;
  calledOnceGlobal: string = '';
  //approvalId:number;
  //userEmail:string;
  //userName: string;
  ngOnInit() {
	
    this.calledOnceGlobal = sessionStorage.getItem("calledOnce");
    console.log("calledOnceGlobal",this.calledOnceGlobal);
    if(this.calledOnceGlobal == null){
    this.route.queryParams.subscribe((params: Params) => {
      this.params = params;
      console.log('App params', params);
      this.id = params['id'];
      console.log('id', this.id);
    });
    this.employeeservice.getOrders(this.id).subscribe((data) =>{
     
       if(Object.keys(data).length != 0) {
          let orders = data as Orders;
       //   let empId = orders.employeeId;
          let lineItems1 = orders.lineItems;
         /* this.employeeservice.getEmployee(empId).subscribe((data:any) => {
            this.approvalId = orders.orderId;
            this.userEmail = data.email;
            this.userName = data.firstName+"&nbsp;"+data.lastName;
          });*/

          forkJoin(
            lineItems1.map((p:any) =>
              this.employeeservice.getItemsById(p.itemId))
          ).subscribe((p:any) => {
            console.log(p);
            let finalApprovalList = lineItems1.map((item:any, i) => {
              if(item.itemId === p[i].itemId) {
                  return Object.assign({}, item, {"item":p[i], "isSelected":''},{"orderId": orders.orderId})
                }
            });
            this.approvalItemsNew = finalApprovalList;
            this.approvalItemsNew.forEach((i) => {
              i.item.isSelected = true;
            });
          
          });

          

        }
      
      })
      }

      
      
  }
  radioChange(event,i) {
	
	
    this.status[i] = event.value;
    this.itemid = event.source.name;
    this.notesiArry[i]='';
    console.log('status',this.status[i]);
    console.log('itemid',this.itemid);
  }
  checkUncheckRadioList(event) {
    let checkVal = (event.target.checked == true) ? true : null;
    this.approvalItemsNew.forEach((i) => {
      i.item.isSelected = checkVal;
    });

    
  }
  hideMessage() {
    this.closeAlertMessage = false;
   }
  onSubmit() {  
    console.log('notes',this.notes);
    let selectedList = [];
    this.approvalItemsNew.forEach((i) => {
      if(i.item.isSelected == true) {
        selectedList.push({
          "isApproved": "Y",
          "itemId": i.itemId
        })
      } else {
        selectedList.push({
          "isApproved": "N",
          "itemId": i.itemId
        })
      }
      
    });
    let finalObject = {
      "approvalItemsList" : selectedList,
      "notes": this.notes
    }
    console.log(finalObject);
   
    this.employeeservice.updateReorderApproval(finalObject, this.id)
      .subscribe(
        (data:Config) => {
          console.log(data);
          if(data.status == 200) {
            this.message = "Updated successfully";
            this.closeAlertMessage = true;
            sessionStorage.setItem("calledOnce","1");
            this.calledOnceGlobal = sessionStorage.getItem("calledOnce");
            this.approvalItemsNew = [];
          }
      })
  }
  onSubmit1(event,approvalItem,i) {
	
    //this.id = event.id;
   // this.itemid = event.source.name;
   
    this.actual_status='';
    console.log('status  ==>',this.status[i]);
    console.log('itemid',approvalItem.itemid);
    console.log('this.notesi', this.notesiArry[i]);
    
    if(this.status[i]=='' || this.status[i]!='yes'){
	   this.actual_status='no';
    }else{
	    this.actual_status='yes';
    }
   console.log('this.actual_status======????>>', this.actual_status);
    
    this.employeeservice.updateReorderApprovalItems(this.id, this.actual_status,approvalItem.itemid, this.notesiArry[i])
      .subscribe(
        data => {
          console.log(data);
            })
    
      event.target.disabled = true;
  }
  
  
  trialtext(e,i){
	
		console.log(e.target.value);
		this.notesiArry[i]=e.target.value;
}
  
  actionMethod(event: any) {
    event.target.disabled = true;
}
  
  
 /* getHTMLAttributeValue(): any {
    console.warn('HTML attribute value: ' + this.bindingInput.nativeElement.getAttribute('value'));
  }*/
  


}
